import React, { useRef, useEffect, useCallback, useState} from 'react';
import ethereum from "decentralized/ethereum.js";
import BackendQuery from "decentralized/BackendQuery.js";
import GuildSamplesContract from "decentralized/contracts/GuildSamplesContract.js";
import {getBulkSampleInfo} from 'components/sidebar/getSamples.js';
import {SampleYear} from "decentralized/EthereumEvents.js"
import {getSoundResultsServer} from 'components/selector2/getSoundResults.js';
import SampleStreamOption from "components/sidebar/SampleStreamOption.js";
import {
    setYearExploring,
    setSourceExploring} from 'actions/index.js';
import {useWindowManager} from "components/windows/useWindowManager.js";
import {connect} from 'react-redux';

const YearExploring = ({
    selectedId,
    setYearExploring,
    year,
    sequencerEngine
}) => { 
    const ref = useRef(undefined);
    const scrollRef  = useRef(undefined);
    const loadingSample = useRef(false);

    const [samples, setSamples] = useState([]);
    const {onMouseDown, onMouseUp, coords, setCoords} = useWindowManager({ref});

    useEffect(() => {
        let elements = document.getElementsByClassName("source-exploring");
        if (elements.length === 0) { return; }

        let el = elements[0];
        setCoords({
            x: el.offsetLeft - 450,
            y: el.offsetTop
        });
    }, [year, setCoords]);
    useEffect(() => {
        if (!year) {
            return;
        }
        ethereum.getGuildsWithAccess()
            .then(guildIds => 
                  new BackendQuery(new GuildSamplesContract().contractAddress)
                  .from(SampleYear)
                  .select("ipfsHash")
                  .where("year", year)
                  .whereIn("guildId", guildIds)
                  .executeQuery()
                  .then(async results => {
                      let ids = Array.from(new Set(results.map(x => x.ipfsHash)));
                      let samples = await getBulkSampleInfo(ids, year);
                      setSamples(samples);
                  }));
                         
    }, [setSamples, year]);

    if (!year) { return []; };
    return (
        <div
          className="year-exploring no-select"
          style={coords ? {left: coords.x, top: coords.y} : {}}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          ref={ref} >
          <div onClick={() => setYearExploring(undefined)} className="clear-btn">x</div>
          <div className="year">
            {year}
            <div className="year-chooser">
              <div onClick={() => setYearExploring(year+1)} className="arrow-up"/>
              <div onClick={() => setYearExploring(year-1)} className="arrow-down"/>
            </div>
          </div>
          <div
            onMouseDown={(e) => e.stopPropagation()}
            ref={scrollRef} className="source-samples">
            {samples.map(
            sample => 
                <SampleStreamOption
                  topOffset={20}
                  scrollRef={scrollRef}
                  key={sample.getId()}
                  samples={samples}
                  onClickTag={() => []}
                  track={sequencerEngine.getSelectedTrack()}
                  selected={selectedId === sample.getId()}
                  id={sample.getId()} sample={sample} loadingSample={loadingSample} />)}
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
    let track = props.sequencerEngine.getSelectedTrack();
  return {
      year: state.selector.yearExploring,
      selectedId: track && track.sample && track.sample.getId(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSourceExploring: x => dispatch(setSourceExploring(x)),
      setYearExploring: x => dispatch(setYearExploring(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(YearExploring);
